import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const sampleLocations = [
  { lat: 37.7749, lng: -122.4194, name: "San Francisco" },
  { lat: 40.7128, lng: -74.006, name: "New York" },
  { lat: 51.5074, lng: -0.1278, name: "London" },
  { lat: 48.8566, lng: 2.3522, name: "Paris" },
  { lat: 35.6895, lng: 139.6917, name: "Tokyo" },
];

const MapOfUsers = () => {
  return (
    <div className="w-full h-full overflow-hidden rounded-lg">
      <h2 className="mt-0 mb-2 text-lg font-bold">Community Map</h2>
      <div className=" w-full h-[calc(100%-3rem)] rounded-lg overflow-hidden" >
        <MapContainer center={[20, 0]} zoom={2} className="w-full h-full rounded-lg">
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {sampleLocations.map((location, index) => (
            <Marker key={index} position={[location.lat, location.lng]}>
              <Popup>{location.name}</Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
};

export default MapOfUsers;
